<template>
  <div>
    <div class="component-title">
      <div class="component-title">
        <h1 class="">First, let's connect to your bank</h1>
        <p style="font-size: 20px;">By doing this we'll be able to automatically calculate your income and expenses.</p>
      </div>
    </div>

    <iframe id="creditSenseIFrame" src="about:blank">
        iframes are not supported in this browser
    </iframe>
    
    <div class="flx loan-container mt-60">
        <a type="button" class="continue-btn continue-btn-small steps-btn"
            href="#" @click.prevent="onContinue('introduce-yourself')">BACK</a>
        <a type="button"
            class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
            href="#" @click.prevent="onContinue('repayment-account')">CONTINUE</a>
    </div>
    <div class="mt-60 clear"></div>
    
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  methods: {
    onContinue(step) {
      this.onChangeStep(step);
    },
  },
};
</script>
